import { User, UserType } from "../entities/User";
import { TApiOrderDetails } from "../api/endpoints/Order";
import { isOrderValid } from "./OrderPolicy";

const DisseminationRequestPolicy = {
  canAccess(user: User, order: TApiOrderDetails) {
    return isOrderValid(order) &&
      user.type === UserType.Admin || user.type === UserType.CCP;
  }
}

export default DisseminationRequestPolicy;
